import { IObservationServiceObj } from '../../../shared/apiServices/IApiInterfaces';
import * as ActionType from '../ActionTypes';

export const SetObservation = (obs: IObservationServiceObj) => {
    return {
        type: ActionType.SET_OBSERVATION_OBJECT,
        payload: obs
    };
}